import React from "react";
import { Box, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithValue = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"TextField with Value"}
        language={"js"}
        value={
          '       <TextField defaultValue="Default Value" label="Outlined" />\n' +
          '      <TextField defaultValue="Default Value" label="Filled" variant="filled" />\n' +
          '      <TextField defaultValue="Default Value" label="Standard" variant="standard" />'
        }
      >
        <TextField defaultValue="Default Value" label="Outlined" />
        <TextField
          defaultValue="Default Value"
          label="Filled"
          variant="filled"
        />
        <TextField
          defaultValue="Default Value"
          label="Standard"
          variant="standard"
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithValue;
